import React, { useCallback, useContext, useEffect } from "react";
// TODO: Setup Sentry for camkit specifically next
// import * as Sentry from "@sentry/react";
import { useService } from "@xstate/react";
import { type Interpreter } from "xstate";

import { type PaginationContext, type PaginationEvents, type PaginationSchema } from "./PaginationMachine";

export type PaginationInterpreter = Interpreter<PaginationContext, PaginationSchema, PaginationEvents>;

export const createPaginationContext = () => React.createContext<PaginationInterpreter | null>(null);

export function usePaginationContext(context: React.Context<PaginationInterpreter>) {
    const service = useContext(context);

    if (!service) {
        throw new Error("usePaginationContext must be used within PaginationProvider");
    }

    return usePaginationService(service);
}

export function usePaginationService(service: PaginationInterpreter) {
    const [state, send] = useService(service.start());
    const isInitial = state.matches("initial");
    const isError = state.matches("error");

    const loadMore = useCallback(() => {
        send("nextPage");
    }, [send]);

    const reset = useCallback(() => {
        send("reset");
    }, [send]);

    const firstLoad = useCallback(() => {
        if (isInitial) {
            send("nextPage");
        }
    }, [isInitial, send]);

    useEffect(() => {
        if (isError) {
            console.info(state.context.error);
            // Sentry.captureException(state.context.error);
        }
    }, [isError, state.context.error]);

    return {
        loading: state.matches("loading"),
        isLastPage: state.matches("lastPage"),
        loadMore,
        reset,
        firstLoad,
        error: state.context.error,
    };
}
